import componentize from '../utils/componentize';

export default function () {
    componentize({
        query: '.fc-slide-inline',
        createdCallback: function () {
            var div = this.querySelector('div'); // first div

            // we could also do this more complexly in the dom by looking at preceding siblings
            // here we expect it declared in an attribute instead
            // var index = parseInt(this.getAttribute('index'), 10) || 0;

            // determine orientation from ratio
            var orientation = ((this.getAttribute('height') / this.getAttribute('width')) > 1) ? 'portrait' : 'landscape';

            // set the right classname for this based on index and orientation
            div.className = ['photo-slide', orientation].join(' ');

            // this.querySelector('p.numbers span').innerHTML = index;
        }
    });
}
